<template>
    <div :class="items.length === 0 ? 'grid-empty' : ''" v-loading="loading">
    	<template v-if="!loading && items.length === 0">
	    	<slot name="no-items">
	    		<div class="list-empty p-4">
			        {{ noItemsMessage }}
			    </div>
	        </slot>
	    </template>

        <div v-for="(item, index) in items"
            class="w-full mb-4"
            :class="itemType() + '-list'"
        >
            <component
                :is="itemType()"
                :item="item"
				:removable="removable"
                :index="index"
                :key="index"
            ></component>
        </div>

		<div class="grid-actions" v-if="paginate && items.length > 0">
			<a v-if="pagination && pagination.to < pagination.total"
			   class="btn btn-default"
			   @click="loadMore"
			>
				<template v-if="loadingMore">Loading...</template>
				<template v-else>Show More</template>
			</a>
		</div>
    </div>
</template>

<script>
    import BaseList from '../mixins/base-list';

    export default {
        mixins: [BaseList]
    }
</script>
